import { render, staticRenderFns } from "./PieGraph.vue?vue&type=template&id=5c1de4ca&scoped=true&"
import script from "./PieGraph.vue?vue&type=script&lang=js&"
export * from "./PieGraph.vue?vue&type=script&lang=js&"
import style0 from "./PieGraph.vue?vue&type=style&index=0&id=5c1de4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1de4ca",
  null
  
)

export default component.exports